var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderPreviousArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FF8C42",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2928 17.7071C13.1053 17.5196 13 17.2653 13 17.0001C13 16.7349 13.1053 16.4806 13.2928 16.2931L18.9498 10.6361C19.042 10.5406 19.1524 10.4644 19.2744 10.412C19.3964 10.3596 19.5276 10.332 19.6604 10.3308C19.7932 10.3297 19.9248 10.355 20.0477 10.4053C20.1706 10.4556 20.2823 10.5298 20.3762 10.6237C20.4701 10.7176 20.5443 10.8292 20.5946 10.9521C20.6449 11.075 20.6702 11.2067 20.669 11.3395C20.6679 11.4723 20.6403 11.6035 20.5879 11.7255C20.5355 11.8475 20.4593 11.9579 20.3638 12.0501L15.4138 17.0001L20.3638 21.9501C20.5459 22.1387 20.6467 22.3913 20.6445 22.6535C20.6422 22.9157 20.537 23.1665 20.3516 23.3519C20.1662 23.5373 19.9154 23.6425 19.6532 23.6448C19.391 23.6471 19.1384 23.5463 18.9498 23.3641L13.2928 17.7071Z",
    fill: "#FF8C42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderPreviousArrow);
export default __webpack_public_path__ + "static/media/slider-previous-arrow.1696fd48e92218defb49688f7a0d019d.svg";
export { ForwardRef as ReactComponent };